import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21141e03"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "语言设置", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "item active" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "label" }, "繁體中文"),
    /*#__PURE__*/_createElementVNode("div", { class: "icon" })
  ])
], -1))
const _hoisted_3 = { class: "box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "投注记录", -1))
const _hoisted_5 = { class: "box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "游戏规则", -1))
const _hoisted_7 = { class: "label" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "item active" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = { class: "label" }
const _hoisted_13 = { class: "box" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "修改密码", -1))
const _hoisted_15 = { class: "box" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "联系客服", -1))
const _hoisted_17 = { class: "box" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "登出游戏", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_lang = _resolveComponent("icon-lang")!
  const _component_icon_arrow = _resolveComponent("icon-arrow")!
  const _component_icon_record = _resolveComponent("icon-record")!
  const _component_icon_rule = _resolveComponent("icon-rule")!
  const _component_icon_speaker = _resolveComponent("icon-speaker")!
  const _component_switch_control = _resolveComponent("switch-control")!
  const _component_icon_chip = _resolveComponent("icon-chip")!
  const _component_icon_cs = _resolveComponent("icon-cs")!
  const _component_icon_exit = _resolveComponent("icon-exit")!

  return (_openBlock(), _createElementBlock("div", {
    class: "setting-root",
    onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["self"]))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["setting-content", { hide: _ctx.hide }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["language", { active: _ctx.activeMenu === 1 }])
      }, [
        _createElementVNode("div", {
          class: "box",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleMenu(1)))
        }, [
          _createVNode(_component_icon_lang, { class: "icon" }),
          _hoisted_1,
          _createVNode(_component_icon_arrow, { class: "arrow" })
        ]),
        _hoisted_2
      ], 2),
      _createElementVNode("div", {
        class: "record",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDialog('record')))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_icon_record, { class: "icon" }),
          _hoisted_4
        ])
      ]),
      _createElementVNode("div", {
        class: "game-rule",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDialog('rule')))
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_icon_rule, { class: "icon" }),
          _hoisted_6
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["speaker", { active: _ctx.activeMenu === 2 }])
      }, [
        _createElementVNode("div", {
          class: "box",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleMenu(2)))
        }, [
          _createVNode(_component_icon_speaker, { class: "icon" }),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.t('systemsetting')), 1),
          _createVNode(_component_icon_arrow, { class: "arrow" })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t('video')), 1),
            _createVNode(_component_switch_control, {
              class: "switch",
              value: _ctx.videoIsOn,
              "onUpdate:value": _ctx.toggleVideo
            }, null, 8, ["value", "onUpdate:value"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.t('soundeffect')), 1),
            _createVNode(_component_switch_control, {
              class: "switch",
              value: _ctx.soundIsOn,
              "onUpdate:value": _ctx.toggleMusic
            }, null, 8, ["value", "onUpdate:value"])
          ])
        ])
      ], 2),
      _createElementVNode("div", {
        class: "password",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDialog('password')))
      }, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_icon_chip, { class: "icon" }),
          _hoisted_14
        ])
      ]),
      _createElementVNode("div", {
        class: "cs",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openCustumerService && _ctx.openCustumerService(...args)))
      }, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_icon_cs, { class: "icon" }),
          _hoisted_16
        ])
      ]),
      _createElementVNode("div", {
        class: "exit",
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.exitGame && _ctx.exitGame(...args)))
      }, [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_icon_exit, { class: "icon" }),
          _hoisted_18
        ])
      ])
    ], 2)
  ]))
}